import Member from 'iam/models/Member'
import { Observable } from 'rxjs'
import { scan, share, switchMap, tap } from 'rxjs/operators'
import { loadZendesk } from './zendesk-loader'

/**
 * Manages the Zendesk integration.
 */
export function ZendeskIntegration(currentMember$: Observable<Member>) {
  const initialState: State = { type: 'Shutdown' }
  const stateMachine$ = currentMember$.pipe(
    switchMap(async (member): Promise<State> => {
      const settings = member.workspace.features.zendesk
      const key = settings.key
      const department = settings.department
      if (!settings.enabled || !key) {
        return { type: 'Shutdown' }
      }

      return {
        member,
        key,
        department,
        type: 'Boot',
        reboot: false,
      }
    }),
    scan<State, State>((prev, next) => {
      // Ensure that we shut down first in case of consecutive boots.
      if (prev.type === 'Boot' && next.type === 'Boot') {
        return {
          ...next,
          reboot: true,
        }
      }

      return next
    }, initialState),
    share()
  )

  return stateMachine$.pipe(
    tap((state) => {
      switch (state.type) {
        case 'Boot': {
          // Memoized.
          loadZendesk(state.key, state.department)

          break
        }
        case 'Shutdown': {
          break
        }
      }
    })
  )
}

/**
 * Action types.
 */
type State = Boot | Shutdown

/**
 * Boots Zendesk.
 */
interface Boot {
  type: 'Boot'
  key: string
  department: string
  member: Member
  /**
   * If `true`, should shutdown first.
   */
  reboot: boolean
}

/**
 * Shuts down Zendesk.
 */
interface Shutdown {
  type: 'Shutdown'
}
